import type { AdminIconProps } from "./UsersIcon";

/** Three vertical bars at increasing heights. */
export function EconomicsIcon({ className, ...rest }: AdminIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={rest["aria-hidden"] ?? true}
    >
      <path d="M5 19V11" />
      <path d="M12 19V5" />
      <path d="M19 19v-9" />
      <path d="M3 19h18" />
    </svg>
  );
}
